import { useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import { useTellerSession } from '~/common/hooks/use-auth/use-teller-session';

export const VIP_KEY = 'checkedAndIs';

interface Methods {
  storedVipState: boolean;
}

export const useVipStateWithCache = (): Methods => {
  const [storedVip, setStoredVipState] = useLocalStorage<boolean>(VIP_KEY);
  const { session } = useTellerSession();

  useEffect(() => {
    if (session?.isAnonymous) {
      setStoredVipState(false);
    }
    if (session?.tellerUser?.isVipUser !== undefined) {
      setStoredVipState(session?.tellerUser.isVipUser);
    }
  }, [session?.isAnonymous, session?.tellerUser?.isVipUser, setStoredVipState]);

  return {
    storedVipState: storedVip ?? session?.tellerUser?.isVipUser ?? false,
  };
};
